import React from 'react';
import HeaderLink from './HeaderLink';
import classNames from 'classnames';

const Header = ({ changeView, view, restartQuiz }) =>  {

  const navRightClass = classNames({
    'header__nav-right': true,
    'header__nav-right--hidden': ['questions', 'results'].indexOf(view) === -1
  });

  const navigateHome = (e) => {
    e.preventDefault();
    changeView('intro');
  }

  return (
    <div className="header">
      <a onClick={e => navigateHome(e)} href="#" target="_blank" className="header__logo">
          <svg viewBox="0 0 27.6 24.2">
              <use xlinkHref="#VAL_logo"></use>
          </svg>
      </a>
      <div className="header__nav">
          <ul className="header__nav-left">
              <HeaderLink changeView={changeView} view={view} href='#' link='questions' text='Gift Finder' />
              <HeaderLink changeView={changeView} view={view} href='#' link='info' text='All Holiday Games' />
              <HeaderLink changeView={changeView} view={view} href='#' link='faq' text='FAQ' />
          </ul>

          <ul className={navRightClass}>
              <li>
                  <a onClick={() => restartQuiz()}>
                      <span className="text" dangerouslySetInnerHTML={{__html: view !== 'results' ? 'Start Over' : 'Find Another Gift'}}></span>
                      <svg className="icon" viewBox="0 0 18 18">
                          <use xlinkHref="#icon-restart"></use>
                      </svg>
                  </a>
              </li>
          </ul>
      </div>
  </div>
  );
}

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/Header/Header.js
 **/